export default __webpack_public_path__ + "static/session-card-bg-1-364237f2989b7cbbe5520a24f8b157a3.png";